import RFLayout from "@/layout/RFLayout";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { ReactElement, useState } from "react";
import FormView from "@/containers/survey/registration/FormView";
import SuccessView from "@/containers/survey/registration/SuccessView";
import { letterSpace } from "@/utils/localeUtils";
import { useTranslation } from "next-i18next";
import useWxShare from "@/hooks/useWxShare";
import HeadMetaContainer from "@/containers/common/HeadMetaContainer";
import bridge from "@/utils/dsBridge";
import { BridgeCallHandlers, BridgeClientShareTypes } from "@/interfaces/enums";

enum UIState {
	FORM = "form",
	SUCCESS = "success",
}

export default function SurveyRegistration({ classN, locale }: { classN: string; locale: string }) {
	const { t } = useTranslation("survey-register");
	const [uiState, setUiState] = useState(UIState.FORM);
	const metaData = {
		title: t("SURVEY_REG_share_title"),
		desc: t("SURVEY_REG_share_desc"),
		imgUrl: `${process.env.NEXT_PUBLIC_APP_OSS_PUBLIC_CND}/h5/survey/register/logo.png`,
	};
	useWxShare(undefined, undefined, { ...metaData });

	const onShare = () => {
		const url = `${window.location.origin}/${locale}/survey/registration`;
		bridge.call(BridgeCallHandlers.ON_SHARE_BUTTON_CLICK, {
			shareTitle: metaData.desc + "\n" + url,
			shareUrl: url,
			shareType: BridgeClientShareTypes.TEXT,
			shareCode: "",
			shareImgUrl: "",
			shareScene: "",
			showCopyButton: 0,
		});
	};

	return (
		<HeadMetaContainer title={metaData.title} description={metaData.desc} imageUrl={metaData.imgUrl}>
			<div className={`w-full h-full bg-[#020205] ${classN}`}>
				{uiState === UIState.FORM && (
					<FormView locale={locale} onShare={onShare} onSuccess={() => setUiState(UIState.SUCCESS)} />
				)}
				{uiState === UIState.SUCCESS && <SuccessView onShare={onShare} />}
			</div>
		</HeadMetaContainer>
	);
}

export const getServerSideProps: GetServerSideProps = async ({ locale = "en" }) => {
	const classN = letterSpace(locale);
	return {
		props: {
			...(await serverSideTranslations(locale, ["survey-register", "error", "common"])),
			classN,
			locale,
		},
	};
};

SurveyRegistration.getLayout = function getLayout(page: ReactElement) {
	return <RFLayout>{page}</RFLayout>;
};
